
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parlor",
      function () {
        return require("private-next-pages/parlor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parlor"])
      });
    }
  